import {
    List,
    ListItemText,
    ListSubheader,
    ListItemButton,
    ListItemIcon,
    TextField,
    Box,
} from "@mui/material";
import { useEffect, useState } from "react";
import ILocal from "../../models/local";
import HBScanStatService from "../../services/stat/HBScanStatService";
import AddIcon from "@mui/icons-material/Add";
import AddLocalModal from "../../components/modal/admin/AddLocalModal";
import EditOnly from "../../components/permissions/EditOnly";
import { useTranslation } from "react-i18next";

type Props = {
    onRoomSelect: (id: number) => void;
    floorId: number;
    buildingId: number;
};

function RoomList({ onRoomSelect, floorId, buildingId }: Props) {
    const [rooms, setRooms] = useState<ILocal[]>([]);
    const [isOpenCreation, setIsOpenCreation] = useState(false);
    const [search, setSearch] = useState("");
    const [searchResults, setSearchResults] = useState<ILocal[]>([]);

    const { t } = useTranslation();

    const open = () => setIsOpenCreation(true);

    useEffect(() => {
        HBScanStatService.getRooms().then((locals) => {
            const rooms = locals.filter((room) => room.floorId === floorId);
            setRooms(rooms);
            setSearchResults(rooms);
            setSearch("");
        });
    }, [floorId]);

    useEffect(() => {
        if (!search) {
            setSearchResults(rooms);
            return;
        }

        setSearchResults(
            rooms.filter(
                (room) =>
                    room.name &&
                    room.name.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search]);

    return (
        <Box sx={{ padding: 2, height: "80vh", width: "25vw" }}>
            <AddLocalModal
                isShowCreate={isOpenCreation}
                setIsShowCreate={setIsOpenCreation}
                onRoomCreate={onRoomSelect}
                floorId={floorId}
                buildingId={buildingId}
            ></AddLocalModal>
            <TextField
                fullWidth
                type="search"
                id="search"
                onChange={(searchBox) => setSearch(searchBox.target.value)}
            />
            <List
                sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        {t("header.rooms")}
                    </ListSubheader>
                }
            >
                <EditOnly>
                    <ListItemButton onClick={open}>
                        <ListItemIcon>
                            <AddIcon />
                        </ListItemIcon>
                        <ListItemText primary={t("button.addRoom")} />
                    </ListItemButton>
                </EditOnly>
                {searchResults.map((room) => (
                    <ListItemButton onClick={() => onRoomSelect(room.id)}>
                        <ListItemText
                            primary={room.name}
                            secondary={room.codes?.join(", ")}
                        />
                    </ListItemButton>
                ))}
            </List>
        </Box>
    );
}

export default RoomList;
